import styled from 'styled-components'
import * as colors from '@giphy/js-brand'
import { mobile } from 'shared/util/media-query'
import LocaleAbTest from 'shared/locale/locale-ab-test'

const Container = styled.div`
    padding-top: 5px;
    ${mobile.css`
        padding: 0;
        margin-bottom: 6px;
        a {
            margin-bottom: 0;
        }
    `}
`

const FollowLabel = styled.p`
    color: ${colors.giphyLightGrey};
    font-weight: 600;
    font-size: 14px;
    margin: 0 0 10px;
    -webkit-font-smoothing: antialiased;
`

const SocialButton = styled.a<{ name: string }>`
    height: 30px;
    width: 30px;
    display: inline-block;
    margin-bottom: 8px;
    margin-right: 5px;
    padding: 7px;
    background-image: url('/static/img/soc-icons/${(props) => props.name}@3x.png');
    background-size: 100%;

    &:last-child {
        margin-right: 0px;
    }
`

type SocialLink = {
    type: string
    url: string | undefined
}

type Props = {
    links: SocialLink[]
    isCompact?: boolean | undefined
}

const Social = ({ links, isCompact }: Props) => {
    return (
        <Container>
            {!isCompact && (
                <FollowLabel>
                    <LocaleAbTest>Follow on</LocaleAbTest>:
                </FollowLabel>
            )}
            {links.map(({ type, url }) => (
                <SocialButton key={type} rel="noopener noreferrer" href={url} target="_blank" name={type} />
            ))}
        </Container>
    )
}

export default Social
